import { render } from "./About.vue?vue&type=template&id=268228f4&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "../assets/css/find.css?vue&type=style&index=0&id=268228f4&scoped=true&lang=css&external"
import "./About.vue?vue&type=style&index=1&id=268228f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268228f4"]])

export default __exports__